import React from "react";
import styled from "@emotion/styled";
import { Toggle } from "kompare-ui-library";
import { colors } from "src/theme";
import { mediaQuery } from "src/common";
import { Flex, Text } from 'src/components';
import { Card } from "./card";

const FlexStyle = styled(Flex)({
  alignItems: 'start',

  [mediaQuery('mobile')]: {
    alignItems: 'center',
  },
})

interface FilterCardProps {
  title?: string;
  description?: string;
  className?: string;
  onToggleChange: (checked: boolean) => void;
  checked?: boolean;
}

export const FilterCard = ({ title, description, onToggleChange, className, checked }: FilterCardProps) => (
  <Card radius={12} padding={'10px 12px'} className={className}>
    <FlexStyle gap={8} justify='space-between'>
      <div>
        {title && <Text type='base' bold color={colors.text2}>{title}</Text>}
        {description && <Text type='small' color={colors.text3}>{description}</Text>}
      </div>
      <Toggle onChange={(c: any) => onToggleChange(c)} checked={checked} labelMarginBottom='0px' />
    </FlexStyle>
  </Card>
);
